import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValueRecognitionTablesComponent } from './components/value-recognition-tables/value-recognition-tables.component';
import { ValueRecognitionTableComponent } from './components/value-recognition-table/value-recognition-table.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ValueRecognitionTablesComponent,
    ValueRecognitionTableComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [ValueRecognitionTablesComponent, ValueRecognitionTableComponent],
})
export class CommonDAEngineerModule {}
